import React, { useState } from "react";
import IMAGES from "../../../../Images";
import {
  FlexContainer,
  MainContainer,
} from "../../../../assets/styles/theme/styles";
import Heading from "../../../../shared/Heading";
import styled from "styled-components";
import Accordion from "../../../../shared/Accordion";

export default function IVRAccordion({
  AccordionData,
  defaultImg,
  mainheading,
  pd,
}) {
  const [img, setImg] = useState(defaultImg);

  function handleImg(src) {
    setImg(src);
  }

  return (
    <>
      <MainContainer>
        <FlexContainer gap="5rem">
          <div style={{ height: "auto", maxWidth: "600px" }}>
            <Heading level={1} style={{ marginBottom: "1rem" }}>
              {mainheading}
            </Heading>
            {AccordionData.map((ele, ind) => {
              return (
                <Accordion
                  key={ind}
                  title={ele.title}
                  hiddenPara={ele.hiddenPara}
                  parentfun={handleImg}
                  hiddenImg={ele.hiddenImg}
                  pd={pd}
                />
              );
            })}
          </div>

          <GlobeImage src={img} alt="" />
        </FlexContainer>
      </MainContainer>
    </>
  );
}

const GlobeImage = styled.img`
  width: 100%;
  height: auto;
  @media (min-width: 1020px) {
    width: 600px;
  }
`;
